<template>
  <div class="report-content">
    <van-loading type="spinner" v-if="loading" vertical class="loading" />
    <ul v-if="list && list.length && !loading">
      <li :key="item.id" v-for="item in list" @click="goToCustomer(item)">
        <div class="top-info">
          <div class="title-info">
            <h3>{{ item.companyName }}</h3>
          </div>
          <div class="split-info">
            <div>
              <p>{{ item.hunterCount || 0 }}</p>
              <p class="label">猎头数量</p>
            </div>
            <div>
              <p>{{ item.todayActiveCount || 0 }}</p>
              <p class="label">今日活跃</p>
            </div>
            <div>
              <p>{{ item.todayChangedCount || 0 }}</p>
              <p class="label">今日动态</p>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <no-data v-if="(!list || !list.length) && !loading"></no-data>
  </div>
</template>

<style lang="scss" scoped>
.report-content {
  height: 100%;
  ul {
    li {
      margin: 1rem 1rem 0;
      padding: 1.5rem;
      background: #ffffff;
      border-radius: 1rem;
      &:first-child {
        margin-top: 1rem;
      }
      .top-info {
        .title-info {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          margin-bottom: 1rem;
          h3 {
            font-size: 1.7rem;
            font-weight: 500;
            color: #333333;
            line-height: 2rem;
          }
          .pa-name {
            font-size: 1.4rem;
            font-weight: 400;
            color: #666666;
            white-space: nowrap;
            overflow: hidden;
            max-width: 11.8rem;
            text-overflow: ellipsis;
          }
        }
        .split-info {
          display: flex;
          justify-content: space-between;
          padding-top: 1rem;
          position: relative;
          &::after {
            content: "";
            width: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background: linear-gradient(to top, #eee 50%, transparent 50%);
            height: 0.1rem;
          }
          div {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            &::after {
              content: "";
              height: 100%;
              position: absolute;
              right: 0;
              top: 0;
              width: 0.1rem;
              background: linear-gradient(to left, #eee 50%, transparent 50%);
            }
            &:last-child {
              &::after {
                content: none;
              }
            }
          }
          p {
            font-size: 1.4rem;
            font-weight: 500;
            color: #333333;
            line-height: 1.5rem;
            &.label {
              font-size: 1.2rem;
              font-weight: 400;
              color: #666666;
              line-height: 1.5rem;
              margin-top: 0.5rem;
            }
          }
        }
      }
    }
  }
}
</style>

<script>
import { getTraceList } from "@/api/report";
import NoData from "@/components/noData";
export default {
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  watch: {
    $route() {},
  },
  computed: {},
  components: {
    NoData,
  },
  methods: {
    goToCustomer(item) {
      this.$router.push({
        name: "reportTraceDetail",
        query: {
          companyId: item.companyId,
        },
      });
    },
    init() {
      this.loading = true;

      let params = {};

      getTraceList(params)
        .then((res) => {
          if (res.data) {
            this.list = res.data.result ? res.data.result : [];
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.init();
  },
};
</script>
